import React, { useEffect, useState } from 'react'
import ApiService from "../../../Services/user/service";
import { MdDescription } from "react-icons/md";
import { useLocation } from "react-router-dom";
const TradeStatement = () => {
  const user_id = localStorage.getItem("user_id");
  const currency = localStorage.getItem("currentCurrency");
  const [TradeStatement, setTradeStatement] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const location = useLocation();
const orderid = location?.state?.orderid;


const fetchTradeStatementOrder = async () => {
  try {
    if (!orderid) return;

    const payload = {
      orderid: [orderid],  
      type: currency === "1" ? "INR" : "USD"
    };

    const res = await ApiService.tradeStatementForOrder(payload);

    setTradeStatement(res?.data?.data || []);
  } catch (err) {
  }
};


  const fwetchTradeStatement = async () => {
    try {
      let res;
      const payload = {
        userid: user_id,
        type: currency === "1" ? "INR" : "USD",
        page: page,
        limit: perPage,
      };
      if (currency === "1") {
        res = await ApiService.getStatementforuser(payload);
      } else {
        res = await ApiService.getStatementforuser(payload);
      }
      setTradeStatement(res?.data?.data || []);
      setPage(res?.data?.currentPage || 1);
      setTotalPages(res?.data?.totalPages || 1);
      setTotalRecords(res?.data?.totalRecords || 0);
    } catch (err) {
    }
  };


useEffect(() => {
  if (orderid) {
    // ✅ ORDER WISE STATEMENT
    fetchTradeStatementOrder();
    
  } else {
    // ✅ NORMAL USER STATEMENT
    fwetchTradeStatement();
  }
}, [orderid, currency, page, perPage]);


  const HandlerOrder = (item) => {
    setModalData(item);
    setIsModalOpen(true);
  };


  const onPageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage); // this triggers fwetchTradeStatement via useEffect
    }
  };

  const handlePerPageChange = (e) => {
    const newPer = Number(e.target.value);
    setPerPage(newPer);
    setPage(1); // reset to first page when page size changes
  };

const hasOrderDetails =
  modalData &&
  (
    (Array.isArray(modalData.orders) && modalData.orders.length > 0) ||
    modalData.qty ||
    modalData.lot ||
    modalData.price
  );

  return (
    //     <div className="container-fluid">
    //         <div className="card">
    //             <div className="card-header">
    //                 <div className="card-title">
    //                       TradeStatement
    //                 </div>
    //             </div>
    //          <div className="card-body">

    //   {TradeStatement.length === 0 ? (
    //     <p>No Records Found</p>
    //   ) : (
    //     TradeStatement.map((item, index) => (
    //       <div
    //         key={index}
    //         className="p-3 mb-2 w-100 shadow-sm"
    //         style={{
    //           border: "1px solid #e5e5e5",
    //           borderRadius: "12px",
    //           background: "#fff",
    //         }}
    //       >
    //         {/* ONE-LINE MAIN ROW */}
    //         <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

    //           {/* SYMBOL */}
    //           <div className="fw-bold" style={{ fontSize: "15px" }}>
    //             {item.symbol}
    //           </div>

    //           {/* TYPE BADGE */}
    //           <span
    //             style={{
    //               padding: "2px 10px",
    //               borderRadius: "20px",
    //               fontSize: "11px",
    //               background: item.type === "CREDIT" ? "#d4f8d4" : "#ffd4d4",
    //               color: item.type === "CREDIT" ? "green" : "red",
    //               fontWeight: 600,
    //             }}
    //           >
    //             {item.type}
    //           </span>

    //           {/* AMOUNT */}
    //           <div style={{ fontSize: "14px" }}>
    //             <strong>₹{Number(item.Amount).toFixed(2)}</strong>
    //           </div>

    //           {/* BROKERAGE */}
    //           <div style={{ fontSize: "13px" }} className="text-muted">
    //             Brg: {item.brokerage}
    //           </div>

    //           {/* BALANCE */}
    //           <div style={{ fontSize: "13px" }} className="text-muted">
    //             Bal: {Number(item.wallet_balance).toFixed(2)}
    //           </div>
    //         </div>

    //         {/* MESSAGE + DATE SMALL BELOW */}
    //         <div className="mt-1 d-flex justify-content-between text-muted" style={{ fontSize: "12px" }}>
    //          <div>
    //            <span>{item.message}</span>
    //          </div>
    //          <div>
    //            <span>{new Date(item.createdAt).toLocaleString()}</span>
    //          </div>
    //             <div>
    //           <button className="btn btn-sm btn-primary">
    //                     Order Details
    //                   </button>
    //         </div>
    //         </div>


    //       </div>
    //     ))
    //   )}
    // </div>


    //         </div>
    //     </div>

    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <div className="card-title"><MdDescription size={28} /> TradeStatement</div>
        </div>

        <div className="card-body  p-3">

          {TradeStatement.length === 0 ? (
            <p>No Records Found</p>
          ) : (
            TradeStatement.map((item, index) => {
              const isCredit = item.type === "CREDIT";
              return (
                <div
                  key={index}
                  className="d-flex flex-column mb-3 statement-card"
                  style={{
                    border: "1px solid rgba(11,102,255,0.08)",
                    borderRadius: 10,
                    background: "#fff",
                    boxShadow: "0 2px 6px rgba(29, 50, 87, 0.06)",
                    padding: "8px 10px",
                  }}
                >
                  {/* TOP ROW */}
                  <div className="d-flex align-items-center justify-content-between" style={{ gap: 12, fontSize: 13 }}>
                    <div className="fw-bold" style={{ fontSize: 14, color: "#1e1f20ff" }}>
                      {item.symbol}
                    </div>


                    <div className="text-muted " style={{ fontSize: 12 }}>
  Brokerage: {currency === "1" ? "₹" : "$"}{Number(item.brokerage).toFixed(2)}
                    </div>

                    <div className="text-muted mt-3" style={{ fontSize: 12 }}>
                      Balance Before Order: {Number(item.wallet_balance).toFixed(2)}

                      {currency === "0" && (
                        <div style={{ marginTop: 2 }}>
                          Balance After Order: {Number(item.after_balance).toFixed(2)}
                        </div>
                      )}
                    </div>


                    <div style={{ color: "#6b7da8" }}>{new Date(item.createdAt).toLocaleString()}</div>
                    <span
                      style={{
                        padding: "4px 10px",
                        borderRadius: 999,
                        fontSize: 11,
                        background: isCredit ? "#d8ecff" : "#dfefff",
                        color: isCredit ? "#278a2fff" : "#cc2e29ff",
                        fontWeight: 700,
                      }}
                    >
                      {item.type}
                    </span>
                  </div>

                  {/* MESSAGE */}
                  <div className="text-muted  " style={{ fontSize: 12, color: "#4b6b9a" }}>
                    {item.message}
                  </div>

                  {/* BOTTOM ROW */}
                  <div className="d-flex align-items-center justify-content-between " style={{ fontSize: 12 }}>

                    <div style={{ fontWeight: 700, color: "#404042ff", fontSize: 13 }}>
                      {currency === "1" ? "₹" : "$"}
                      {currency === "0" && item.orders?.length
                        ? Number(item.orders[0].totalAmount).toFixed(3)
                        : Number(item.Amount).toFixed(2)
                      }
                    </div>



                    <button
                      className="btn btn-sm"
                      style={{
                        padding: "4px 8px",
                        fontSize: 12,
                        background: "#084abbff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                      }}

                      onClick={() => HandlerOrder(item)}

                    >
                      Order Details
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>

{!orderid && (
        <div className="pagination d-flex bg-light justify-content-between align-items-center py-3 px-3">

          {/* LEFT SIDE */}
          <div className="d-flex align-items-center gap-2">
            <label className="mb-0">Rows per page:</label>
            <select
              className="form-select form-select-sm"
              style={{ width: 90 }}
              value={perPage}
              onChange={handlePerPageChange}
            >
              {[5, 10, 20, 50, 100].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
            <small className="ms-2 text-muted">
              {totalRecords} records
            </small>
          </div>

          {/* RIGHT SIDE */}
          <div className="d-flex align-items-center">
            <button
              className="btn btn-outline-primary"
              disabled={page === 1}
              onClick={() => onPageChange(page - 1)}
            >
              ◀ Prev
            </button>

            <span className="mx-3">Page {page} of {totalPages || 1}</span>

            <button
              className="btn btn-outline-primary"
              disabled={page === totalPages || totalPages === 0}
              onClick={() => onPageChange(page + 1)}
            >
              Next ▶
            </button>
          </div>

        </div>
)}
      </div>



      {isModalOpen && modalData && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(6px)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
                boxShadow: "0 12px 32px rgba(0,0,0,0.25)",
                border: "1px solid rgba(255,255,255,0.25)",
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  background: "linear-gradient(135deg, #1e0eadff, #22069eff)",
                  color: "#fff",
                  borderBottom: "none",
                  padding: "16px 20px",
                }}
              >
                <h5 className="modal-title fw-bold" style={{ fontSize: "18px" }}>
                  Order Details
                </h5>
                <button
                  className="btn-close btn-close-white"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  background: "#f4f7ff",
                  padding: "20px",
                  fontSize: "14px",
                }}
              >

                {/* REUSABLE LINE ITEM */}
                <div className="mb-3 modal-detail-row">

                  <span className="text-muted small">Trade Symbol</span>
                  <span className="fw-bold text-uppercase text-success">{modalData.symbol}</span>
                </div>

                <div className="mb-3 modal-detail-row">

                  <span className="text-muted small">Trade Date & Time</span>
                  <span className="fw-semibold">
                    {new Date(modalData.createdAt).toLocaleString()}
                  </span>
                </div>

                <div className="mb-3 modal-detail-row">

                  <span className="text-muted small">Transaction</span>
                  <span
                    style={{
                      padding: "4px 12px",
                      borderRadius: "12px",
                      background:
                        modalData.type === "CREDIT" ? "#d9ffe8" : "#ffe0e0",
                      color: modalData.type === "CREDIT" ? "#0a8f3a" : "#d32626",
                      fontWeight: 600,
                    }}
                  >
                    {modalData.type}
                  </span>
                </div>

                {/* {modalData.orders && modalData.orders.length > 0 &&(
                  <>
                    <div className="mb-3 modal-detail-row">

                      <span className="text-muted small">Net Amount</span>
                      <span
                        className="fw-bold"
                        style={{
                          color: modalData.type === "CREDIT" ? "#0a8f3a" : "#d60f0f",
                        }}
                      >
                        ₹{Number(modalData.Amount).toFixed(4)}
                      </span>
                    </div>
                    <div className="mb-3 modal-detail-row">

                      <span className="text-muted small">Qty</span>
                      <span className="fw-semibold">
                        {modalData.orders[0].qty}
                      </span>
                    </div>

                    <div className="mb-3 modal-detail-row">

                      <span className="text-muted small">Lot</span>
                      <span className="fw-semibold">
                        {modalData.orders[0].lot}
                      </span>
                    </div>

                    <div className="mb-3 modal-detail-row">

                      <span className="text-muted small">Price</span>
                      <span className="fw-semibold">
                        ₹{modalData.orders[0].price}
                      </span>
                    </div>

                     <div className="mb-3 modal-detail-row">

                      <span className="text-muted small">Exittype</span>
                      <span className="fw-semibold">
                        ₹{modalData.Exittype}
                      </span>
                    </div>
                  </>
                )} */}
{hasOrderDetails && (
  <>
    <div className="mb-3 modal-detail-row">
      <span className="text-muted small">Net Amount</span>
      <span className="fw-bold">
        ₹{modalData.orders?.[0]?.totalAmount ?? modalData.totalamount ?? modalData.Amount}
      </span>
    </div>

    <div className="mb-3 modal-detail-row">
      <span className="text-muted small">Qty</span>
      <span className="fw-semibold">
        {modalData.orders?.[0]?.qty ?? modalData.qty}
      </span>
    </div>

    <div className="mb-3 modal-detail-row">
      <span className="text-muted small">Lot</span>
      <span className="fw-semibold">
        {modalData.orders?.[0]?.lot ?? modalData.lot}
      </span>
    </div>

    <div className="mb-3 modal-detail-row">
      <span className="text-muted small">Price</span>
      <span className="fw-semibold">
        ₹{modalData.orders?.[0]?.price ?? modalData.price}
      </span>
    </div>

    {modalData.Exittype && (
      <div className="mb-3 modal-detail-row">
        <span className="text-muted small">Exit Type</span>
        <span className="fw-semibold">{modalData.Exittype}</span>
      </div>
    )}
  </>
)}

              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{
                  borderTop: "1px solid #d6e1ff",
                  background: "#f4f7ff",

                }}
              >
                <button
                  className="btn fw-semibold"
                  style={{
                    background: "#2b2d30",
                    color: "#fff",
                    borderRadius: "8px",

                  }}
                  onClick={() => setIsModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}





    </div>

  )
}

export default TradeStatement